<template>
	<div class="container">
		<el-card>
			<div slot="header">黑名单管理</div>
			<div style="height: 100%">
				<el-button icon="el-icon-edit" style="background-color: #23c6c8 !important" @click="removeBlacklist">
					移出黑名单</el-button>
				<el-form ref="form" :model="queryParams" label-width="80px" size="small" class="searchForm"
					style="margin-top: 15px">
					<el-form-item label="商户编号" label-width="70px">
						<el-input v-model="queryParams.code" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.name" placeholder="" clearable class="searchTag" filterable>
							<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" size="small" icon="el-icon-search" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" style="width: 100%" height="92%" ref="merchantInfoTable"
						highlight-current-row @current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" align="center">
						</el-table-column>
						<el-table-column prop="code" label="商户编号" width="100" align="center">
						</el-table-column>
						<el-table-column prop="name" label="商户名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="contactMan" label="商户联系人" width="100" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="联系人电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="systemAdmin" label="小程序联系人" width="110" align="center">
						</el-table-column>
						<el-table-column prop="systemAdminPhone" label="小程序联系人电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="detailAddress" label="联系地址" width="150" align="center">
						</el-table-column>
						<el-table-column prop="electricBalance" label="电账户余额（元）" width="140" align="center">
						</el-table-column>
						<el-table-column prop="waterBalance" label="水账户余额（元）" width="140" align="center">
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" width="160" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		selectList,
		removeBlacklist
	} from '../../api/property/blacklistManagement';
	import {
		translateObjectEmptyAttributeToNull
	} from '../../untils/func';


	export default {
		data() {
			return {
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
				lesseeNameOptions: [],
				form: {},
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
				},
				loading: false,
				total: 0,
				tableData: [],
				currentRow: null
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQuery();
				await this.getLesseeNameOption();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			// 添加黑名单
			async removeBlacklist() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await removeBlacklist({
						lesseeId: this.currentRow
					}).then();
					this.msgSuccess('操作成功');
					await this.handleQuery();
				}
			},

			// 单选表格某一行
			handleCurrentChange(val) {
				this.currentRow = val.id;
			},
			cancelChoose() {
				this.$refs.merchantInfoTable.setCurrentRow();
				this.currentRow = null;
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.lesseeNameOptions = response.data;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	.el-cascader {
		width: 100%;
	}

	.searchTag {
		width: 130px;
	}

	.el-dialog .el-form-item {
		width: 100%;
	}

	.changeAppletClass {
		/deep/.el-form-item {
			margin-bottom: 10px;
		}
	}

	/deep/ .saveStyle {
		width: 100%;
		text-align: center;
		padding-bottom: 15px;
		border-bottom: 1px dashed #999;
	}

	.tableStyle {
		height: calc(100% - 84px);
	}

	.searchForm {
		.el-form-item {
			margin-bottom: 10px;
		}
	}

	.block {
		margin-top: 10px;
	}
</style>
